/**
 * Icônes custom des apps (bureau / taskbar / onglets / sélecteur).
 *
 * Pour remplacer l'icône Phosphor par défaut d'une app, dépose un fichier
 * dans `public/icons/apps/<slug>.png` (ou `.svg`) PUIS ajoute une entrée ici.
 * Le `slug` = l'`id` de l'app (qui vaut aussi son `launchPanelId` pour les
 * apps de canal : `twitter`, `telegram`, `conversations`, …). Voir
 * `public/icons/apps/README.md`.
 *
 * Sécurité : si le fichier est absent ou échoue à charger, `<AppGlyph>`
 * retombe automatiquement sur l'icône Phosphor. Une entrée pointant vers un
 * fichier manquant est donc inoffensive.
 */
export const CUSTOM_APP_ICONS: Record<string, string> = {
  twitter: "/icons/apps/twitter.png",
  telegram: "/icons/apps/telegram.png",
  conversations: "/icons/apps/conversations.png",
  spaces: "/icons/apps/spaces.png",
  vault: "/icons/apps/vault.png",
  creators: "/icons/apps/creators.png",
  personnel: "/icons/apps/personnel.png",
  organisation: "/icons/apps/organisation.png",
};

/** URL de l'icône custom pour un slug d'app, ou `undefined` si aucune. */
export function getCustomAppIcon(slug: string | undefined): string | undefined {
  return slug ? CUSTOM_APP_ICONS[slug] : undefined;
}
